<template>
    <div class="row">
        <div class="col-xxl-2 col-xl-3 border-end border-end-xl">
            <aside class="sidebar sticky-lg-top sticky-pernet">

                <div class="filters">
                <ul class="list-unstyled list-cat-mobile" id="categories">
                    <li  v-for="(category, index) in categories">
                        <div class="form-check">
                            <input class="form-check-input" type="radio"  :value="category.id"  :id="'category'+index" v-model="selected.categories">
                            <label class="form-check-label" :for="'category' + index">
                                {{ category.name }}
                            </label>
                        </div>
                    </li>
                </ul>
                </div>

                <div id="advanced-filter">
                    <div class="filters mb-3">
                        <div class="inner-fitler">
                 <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#promo" role="button" aria-expanded="true" aria-controls="promo">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Promos / Nouveautés
                 </span>

                                <ul class="collapse list-unstyled" id="promo">
                                    <!--<li>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="promotions">
                                            <label class="form-check-label" for="promotions">
                                                Promotions
                                            </label>
                                        </div>
                                    </li>-->
                                    <li>
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value="" id="nouveautes" v-model="selected.nouveautes">
                                            <label class="form-check-label" for="nouveautes">
                                                Nouveautés
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                        </div>

                        <div class="inner-filter">
                                <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#packagings"
                                      role="button" aria-expanded="true" aria-controls="packagings">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Conditionnement
                 </span>
                                <ul class="collapse list-unstyled" id="packagings" >
                                    <li v-for="(packaging, index) in packagings">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox"  :value="packaging.code"  :id="'packaging'+index" v-model="selected.packagings">
                                            <label class="form-check-label" :for="'packaging' + index">
                                                {{ packaging.label }}
                                            </label>
                                        </div>
                                    </li>
                                </ul>

                        </div>
                    </div>
                    <!--<button type="reset" class="btn w-100 btn-default" v-on:click="resetFilters()"><i class="fas fa-times small"></i> Réinitialiser les filtres</button>-->
                </div>



            </aside>
        </div>

        <div class="col-xxl-10 col-xl-9">

            <div :class="{'loading': loading}">
                <div class="products row" >
                    <div v-if="products.length" class="row">

                        <shop-item v-for="item in products" :item="item" :key="item.id">
                        </shop-item>
                        <nav aria-label="course" class="navigation-grille">
                            <ul class="pagination">
                                <li class="page-item" :class="{ 'disabled': meta.current_page ===1 }">
                                    <a class="page-link" href="#" @click.prevent="switched(meta.current_page - 1)">
                    <span>
                        &laquo;
                    </span>
                                    </a>
                                </li>
                                <li class="page-item" :class="{ 'active': meta.current_page === x }" v-for="x in meta.last_page">
                                    <a class="page-link" href="#" @click.prevent="switched(x)">{{ x }}</a>
                                </li>
                                <li class="page-item" :class="{ 'disabled': meta.current_page === meta.last_page }">
                                    <a class="page-link" href="#" @click.prevent="switched(meta.current_page + 1)">
                    <span>
                        &raquo;
                    </span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div v-else>
                        <div v-if="listing && !search" class="row">


                            <div class="col-xxl-3 col-lg-4 col-6 mb-4" v-for="c in categories">
                                <a :href="c.url" class="border d-block text-center text-decoration-none text-dark ">
                                    <img :src="c.src" width="500" height="500" :alt="c.name" class="img-fluid bg-secondary" loading="lazy">
                                    <span class="h4 fw-bold pt-2">{{ c.name }}</span>
                                </a>
                            </div>
                        </div>
                        <div v-else>
                            <p>Aucun Produit Trouvé avec votre recherche.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Catalogue-Mobile',
    props: ['listing'],
    data: function () {
        return {
            loading: true,
            cadencier: true,
            search: false,
            page: 1,
            meta: null,
            products: [],
            categories: [],
            packagings: [],
            selected: {
                categories: 1,
                packagings: [],
                promotions: false,
                nouveautes: false
            }
        }
    },
    mounted() {
        this.loadProductsSearch();
        this.loadPackaging();
        this.loadCategories();
    },
    watch: {
        selected: {
            handler: function () {
                this.search = true;
                this.page = 1;
                this.loadProductsSearch();
            },
            deep: true
        }
    },
    methods: {
        loadCategories: function() {
            axios.get('/api/categories', {
            })
                .then((response) => {
                    this.categories = response.data.data;
                    this.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadPackaging: function() {
            axios.get('/api/packaging', {
            })
                .then((response) => {
                    this.packagings = response.data.data;
                    this.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadProducts: function() {
            axios.get('/api/catalogue-public', {
                params: {
                    user_id: this.user_id
                }
            })
                .then((response) => {
                    this.products = response.data.data;
                    this.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        loadProductsSearch: function() {
            let dataPass = {...this.selected, 'keyword' : this.keyword, 'page': this.page};
            axios.get('/api/search-produtcs',{
                params: dataPass
            })
                .then((response) => {
                    this.products = response.data.data;
                    this.loading = false;
                    this.meta = response.data.meta;
                    let anchor = document.querySelector('#pernet-app');
                    anchor.scrollIntoView(
                        {
                            behavior: 'smooth'
                        }
                    );
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        switched(pageVal){
            this.page = pageVal;
            this.loadProductsSearch();
            let anchor = document.querySelector('#pernet-app');
            anchor.scrollIntoView(
                {
                    behavior: 'smooth'
                }
            );
        },
        resetFilters()
        {
            this.search = false;
            this.selected.packagings = [];
            this.selected.categories = false;
            this.selected.nouveautes = false;
            this.selected.promotions = false;
        }
    }
}
</script>
